import { graphql, useStaticQuery } from "gatsby";

// banner {
//   title
//   backgroundImage {
//     gatsbyImageData(
//       formats: [AUTO, WEBP]
//       layout: CONSTRAINED
//       placeholder: BLURRED
//       width: 600
//     )
//   }
//   buttonText
//   buttonLink
// }
export const UseNavbarShop = () => {
  const data = useStaticQuery(graphql`
    fragment Secondary on ContentfulSecondaryMenu {
      title
      mainLinks {
        id
        title
        slug
      }
      collections {
        id
        title
        slug
      }
    }

    {
      contentfulNavbar {
        clothing {
          ...Secondary
        }
        camping {
          ...Secondary
        }
        rooftopTents {
          ...Secondary
        }
        accessories {
          ...Secondary
        }
        hunting {
          ...Secondary
        }
        hideSale
        hideBundles
        sale {
          id
          title
          slug
        }
        helpLinksHeading
        helpBG {
          title
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            formats: [WEBP, AUTO]
          )
        }
        helpLinks {
          id
          title
          slug
        }
        helpFooterLinks {
          id
          title
          slug
        }
        contactDetails {
          raw
        }
      }
    }
  `);

  return data.contentfulNavbar;
};
